import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { User as action } from '../../redux/actions';

/**
 * Makes the user delete
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const remove = (properties) => {
  const props = assign(properties);
  const model = {
    Users: props.data.map(item => ({
      Username: item.username,
    })),
  };

  fetch(endpoint('/delete-users'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.remove(model.Users));
        }
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default remove;
